import axios from 'axios'
import qs from 'qs'

export const signup = async (data, searchUrl, recaptchaToken) => {
  const queryString = qs.parse(searchUrl, { ignoreQueryPrefix: true })
  const redirect = !queryString.redirect ? '/' : queryString.redirect

  const response = await axios
    .post('/api/boitata/v1/signup', data, {
      headers: {
        'Redirect-URL': redirect,
        'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]')
          .content,
        'G-Recaptcha': recaptchaToken
      }
    })
    .then(({ data }) => data)
    .catch(err => {
      throw err.response
    })

  return response
}

export const signupCompany = async (data, recaptchaToken) => {
  const response = await axios
    .post('/api/boitata/v1/company/signup', data, {
      headers: {
        'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]')
          .content,
        'G-Recaptcha': recaptchaToken
      }
    })
    .then(({ data }) => data)
    .catch(err => {
      throw err.response
    })

  return response
}

export const getCompany = async data => {
  const response = await axios
    .get(`/api/boitata/v1/company/search?fiscalId=${data}`)
    .then(({ data }) => data.data)
    .catch(err => {
      throw err.response
    })

  return response
}

export const getCep = async cep => {
  const response = await axios
    .get(`/endereco/${cep}`)
    .then(({ data }) => data)
    .catch(err => {
      throw err.response
    })

  return response
}

export const getStores = async region => {
  const response = await axios
    .get(`/api/v3/regions/${region}/stores`)
    .then(({ data }) => data)
    .catch(err => {
      throw err.response
    })

  return response
}
